import { render, staticRenderFns } from "./WorkspaceConferenceDocument.vue?vue&type=template&id=46ac30f5&scoped=true"
import script from "./WorkspaceConferenceDocument.vue?vue&type=script&lang=js"
export * from "./WorkspaceConferenceDocument.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceConferenceDocument.vue?vue&type=style&index=0&id=46ac30f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ac30f5",
  null
  
)

export default component.exports